import React, { useMemo } from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Checkboxes, DateTime, User, RequiredValidator, EventTriggers } from '../../Components/Form';
import { useJobs, useRound } from '../../Data/Rounds';
import { FieldLoading } from '../../Components/Loading';
import { statuses } from '../../Data/Jobs';
import { plural } from '../../Services/helpers';
import { usePreference } from '../../Data/Preference';
import { eventTriggers } from '../../Data/Misc';

const ScheduleRound = ({round, jobs, isOpen, onClose, onSave, prefillData, panel}) => {
    return <Modal title="Schedule round" isOpen={isOpen} setIsOpen={onClose} dismissible>
        {panel && panel}
        {round && <Inner {...{round, jobs, onSave, prefillData}} />}
    </Modal>
}

const Inner = ({round, jobs, onSave, prefillData}) => {
    const {schedule} = useRound(round.id);
    const {jobs: roundJobs} = useJobs(round.id, true, 'customer', !!jobs);
    const [selectedStatuses, setSelectedStatuses] = usePreference('scheduleRound.jobStatuses', Object.keys(statuses));

    const formData = prefillData ? prefillData : {statuses: selectedStatuses};

    return <Form
            data={formData}
            onSubmit={data => schedule(data)}
            afterSubmit={onSave}
            closeModalOnSubmit
        >
        <DateTime name="date" label="Date" time={false} validators={[RequiredValidator]} showDatePrompts />
        <User name="assignedTo" label="Assign to" validators={[]} />
        <JobStatuses jobs={jobs ?? roundJobs} onChange={setSelectedStatuses} />
        <EventTriggers triggers={[eventTriggers.SEND_NOTIFICATIONS]} />
        <Actions submit={{label: 'Schedule'}} cancel />
    </Form>
}

const JobStatuses = ({jobs, onChange}) => {
    const checkboxStatuses = useMemo(() => {
        if (!jobs) {
            return null;
        }

        return Object.keys(statuses).reduce((acc, status) => {
            const jobsWithStatus = jobs.filter(j => j.status === status);

            if (jobsWithStatus.length) {
                acc.push({
                    label: status+' '+plural(jobsWithStatus.length, '(0 jobs)', '(1 job)', `(${jobsWithStatus.length} jobs)`),
                    value: status,
                });
            }

            return acc;
        }, []);
    }, [jobs]);

    if (!jobs || !checkboxStatuses) {
        return <FieldLoading label="Job statuses" />;
    }

    if (jobs.length === 0) {
        return null;
    }

    return <Checkboxes name="statuses"
        label="Job statuses"
        options={checkboxStatuses}
        onChange={onChange}
    />
}

export default ScheduleRound;
